export enum Status {
    DRAFT = 'DRAFT',
    NEW = 'NEW',
    CREATED_IN_CRM = 'CREATED_IN_CRM',
    CONFIRMED = 'CONFIRMED',
    CANCELED = 'CANCELED'
  }
